import ExtendStore from "../base/extendStore"
import { Stores } from '..';
import LeftNavStore from './leftNavStore';
import ProcessMonitoringStore from './subModules/processMonitoring/processMonitoringStore'
import NavConfigStore from './subModules/navConfig/navConfigStore'
import HomePagePushStore from './subModules/homePagePush/homePagePushStore'
import HotPersonStore from "./subModules/hotPerson/hotPersonStore";
import { observable, action } from 'mobx';
import SearchTemplateStores from './subModules/search/searchTemplateStore/searchTemplateStore';
import contentMgTypes from 'src/types/contentMgTypes';

export default class ManageCenterStore extends ExtendStore {
   public leftNavStore:LeftNavStore
   public processMonitoringStore:ProcessMonitoringStore
   public navConfigStore:NavConfigStore
   public searchTemplateStores: SearchTemplateStores
   public homePagePushStore:HomePagePushStore
   public hotPersonStore:HotPersonStore
   @observable
   public iframeInfo: contentMgTypes.IIframeInfo = {
       src: '',
       show: false
   };

   public constructor(stores: Stores){
      super(stores);
      this.leftNavStore = new LeftNavStore(stores, this)
      this.processMonitoringStore = new ProcessMonitoringStore(stores, this)
      this.navConfigStore = new NavConfigStore(stores)
      this.searchTemplateStores = new SearchTemplateStores(stores, this);
      this.homePagePushStore = new HomePagePushStore(stores, this)
      this.hotPersonStore = new HotPersonStore(stores, this)
   }

   @action
    public setIframeInfo(info: contentMgTypes.IIframeInfo){
        this.iframeInfo = info;
    }
}
